<template>
  <div class="perfect-theme-config">
    <ContentHeader />

    <div class="content-container">
      <div class="perfect-theme">
        <div v-loading="loading">
          <!-- 选择bu/Region -->
          <div class="content">
            <div class="row" style="padding: 10px 0">
              <div class="sub-title require">
                {{ employeeLevel > 50 ? "选择BU" : "选择Region" }}
              </div>
              <PerfectThemeOrg
                ref="org"
                :placeholder="employeeLevel > 50 ? 'BU' : 'Region'"
                :disable="pageType === 'update'"
                :orgList="orgList"
                :info="tradePerfectThemeDefineDTO"
              >
              </PerfectThemeOrg>
            </div>
          </div>

          <!-- 活动信息 -->
          <div>
            <div class="primary-title">活动信息</div>
            <div class="content">
              <div class="row">
                <div class="sub-title">主题名称</div>
                <div class="sub-content">
                  {{ originInfo.themeName }}
                  <!-- <i class="el-icon-edit icon-edit" v-if="isBuUser" @click="editThemeName"></i> -->
                </div>
              </div>

              <div class="row">
                <div class="sub-title">渠道</div>
                <div class="sub-content">{{ originInfo.channelName }}</div>
              </div>

              <div class="row">
                <div class="sub-title">活动时间</div>
                <div class="sub-content">
                  {{ originInfo.startDate | parseTime("{y}-{m}-{d}") }} 至
                  {{ originInfo.endDate | parseTime("{y}-{m}-{d}") }}
                </div>
              </div>

              <div class="row">
                <div class="sub-title require">
                  <div class="sub-title-main">
                    执行周数<span class="sub-title-unit">（周）</span>
                  </div>
                  <!-- <div class="sub-title-unit">（周）</div> -->
                  <div class="sub-title-mod">
                    {{ getChooseTypeHint("execWeek") }}<br />
                    <span v-if="originInfo.execWeekMin!==null&&!isDetailPage">{{
                      getScopeHint(
                        originInfo.execWeekMax,
                        originInfo.execWeekMin
                      )
                    }}</span>
                  </div>
                </div>
                <div class="sub-content">
                  <PerfectThemeMixField
                    ref="execWeek"
                    commonKey="execWeek"
                    :employeeLevel="employeeLevel"
                    :matchInfo="matchInfo"
                    :originInfo="originInfo"
                    >周</PerfectThemeMixField
                  >
                </div>
              </div>

              <div class="row">
                <div class="sub-title require">陈列追踪方式</div>
                <div class="sub-content">
                  <PerfectThemeCheckbox
                    ref="trackType"
                    commonKey="trackType"
                    :matchInfo="matchInfo"
                    :originInfo="originInfo"
                  ></PerfectThemeCheckbox>
                </div>
              </div>

              <div class="row">
                <div class="sub-title require">费用返还方式</div>
                <div class="sub-content">
                  <PerfectThemeCheckbox
                    ref="bonusType"
                    commonKey="bonusType"
                    :matchInfo="matchInfo"
                    :originInfo="originInfo"
                    @change="bonusTypeChange"
                  ></PerfectThemeCheckbox>
                </div>
              </div>

              <!-- <div class="row" v-show="hasBonusBeerType">
                <div class="sub-title require">赠酒SKU</div>
                <div class="sub-content">
                  <PerfectThemeCheckbox
                    ref="bonusBeerSku"
                    commonKey="bonusBeer"
                    :matchInfo="matchInfo"
                    :originInfo="originInfo"
                  ></PerfectThemeCheckbox>
                </div>
              </div> -->

              <!-- 可自定义添加赠酒sku -->
              <div class="row" v-show="hasBonusBeerType">
                <div class="sub-title require">赠酒SKU</div>
                <div class="sub-content">
                  <PerfectThemeCheckbox
                    ref="bonusBeerSku"
                    commonKey="bonusBeer"
                    :showAdd="employeeLevel > 50"
                    :matchInfo="matchInfo"
                    :originInfo="originInfo"
                  ></PerfectThemeCheckbox>
                </div>
              </div>

              <!-- 销售是否必选经销商 -->
              <!-- <div class="row" v-if="isBuUser">
                <div class="sub-title require">销售必选经销商</div>
                <div class="sub-content">
                  <el-radio-group v-model="matchInfo.flagWsRequired">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <!-- 任务列表 是否勾选任务-->
        <div class="task" v-loading="loading">
          <div class="task-wrapper" :style="`justify-content:${getTaskContentWidth}`">
            <div
              class="task-content"
              v-for="item in taskCheckedList"
              :key="item.key"
              v-show="item.showTask"
            >
              <div class="task-title">{{ item.title }}</div>
              <el-checkbox
                :disabled="isDetailPage"
                class="taskCheckbox"
                v-model="item.checked"
                >{{ item.checked ? "启用" : "禁用" }}</el-checkbox
              >
            </div>
          </div>
        </div>

        <!-- tab 栏 -->
        <div class="tab" v-loading="loading">
          <el-tabs v-model="activeName" type="card">
            <template v-for="item in taskCheckedList">
              <el-tab-pane
                v-if="item.checked"
                :key="item.key"
                :label="item.title"
                :name="item.title"
              >
              </el-tab-pane>
            </template>
            <!-- 堆箱任务 -->
            <div
              v-show="activeName === '堆箱任务' && taskCheckedList[0].checked"
            >
              <div class="content content-tab">
                <!-- 品牌 子品牌展示 -->
                <div class="row">
                  <div class="sub-content">
                    <PerfectThemeBrand
                      :baseInfo="brandInfo"
                    ></PerfectThemeBrand>
                  </div>
                </div>

                <div class="row">
                  <div class="sub-title">单品牌堆箱规格</div>
                  <div class="sub-content">
                    <PerfectThemeCheckbox
                      ref="stackSize"
                      :showAdd="employeeLevel > 50"
                      :employeeLevel="employeeLevel"
                      commonKey="stackSize"
                      :matchInfo="stackMatchInfo"
                      :originInfo="stackOriginInfo"
                      @addNew="handleAddNewStackSize"
                    ></PerfectThemeCheckbox>
                  </div>
                </div>

                <div class="row">
                  <div class="sub-title">单张拍照激励金额/周</div>
                  <div v-if="!isDetailPage && isBuUser" class="sub-title-mod">
                    <el-input-number
                      v-model="stackMatchInfo.incentiveFee"
                      controls-position="right"
                      :min="0"
                      size="small" />
                  </div>
                  <div v-else class="sub-content">
                    {{
                      stackMatchInfo.incentiveFee || 0
                    }}元
                  </div>
                </div>

                <div class="row" v-show="hasBonusFeeType">
                  <div class="sub-title require">
                    <div class="sub-title-main">
                      陈列费/周<span class="sub-title-unit">（元）</span>
                    </div>
                    <!-- <div class="sub-title-unit">（元）</div> -->
                    <div class="sub-title-mod">
                      {{ getChooseTypeHint("bonusFeeStack") }}<br />
                      <span v-if="stackOriginInfo.bonusFeeMin!==null&&!isDetailPage">{{
                        getScopeHint(
                          stackOriginInfo.bonusFeeMax,
                          stackOriginInfo.bonusFeeMin
                        )
                      }}</span>
                    </div>
                  </div>
                  <div class="sub-content">
                    <PerfectThemeMixField
                      ref="bonusFeeStack"
                      commonKey="bonusFee"
                      :employeeLevel="employeeLevel"
                      :matchInfo="stackMatchInfo"
                      :originInfo="stackOriginInfo"
                      >元</PerfectThemeMixField
                    >
                  </div>
                </div>
                <div class="row" v-show="hasBonusBeerType">
                  <div class="sub-title require">
                    <div class="sub-title-main">
                      赠酒数/周<span class="sub-title-unit">（箱）</span>
                    </div>

                    <div class="sub-title-mod">
                      {{ getChooseTypeHint("bonusBeerStack") }}<br />
                      <span v-if="stackOriginInfo.bonusBeerMin!==null&&!isDetailPage">{{
                        getScopeHint(
                          stackOriginInfo.bonusBeerMax,
                          stackOriginInfo.bonusBeerMin
                        )
                      }}</span>
                    </div>
                  </div>
                  <div class="sub-content">
                    <PerfectThemeMixField
                      ref="bonusBeerStack"
                      commonKey="bonusBeer"
                      :employeeLevel="employeeLevel"
                      :matchInfo="stackMatchInfo"
                      :originInfo="stackOriginInfo"
                      >箱</PerfectThemeMixField
                    >
                  </div>
                </div>
              </div>

              <!-- 堆箱 混堆设计类型 -->
              <div class="content margin-top-20">
                <div class="row">
                  <div class="sub-content">
                    <PerfectThemeConfigDesign
                      ref="stackTaskDesign"
                      :employeeLevel="employeeLevel"
                      :originDefineInfo="originDefineInfo"
                      :tradeStackThemeDefineDTO="tradePerfectThemeDefineDTO"
                      :regionListByBu="regionListByBu"
                      :selectedOrgCode="selectedOrgCode"
                    >
                    </PerfectThemeConfigDesign>
                  </div>
                </div>
              </div>

              <!-- 堆箱 组合陈列套餐配置 -->
              <div class="content margin-top-20">
                <div class="row">
                  <div class="sub-content">
                    <PerfectThemeConfigMixing
                      ref="stackTaskMixing"
                      componentName="堆箱组合陈列套餐配置"
                      :employeeLevel="employeeLevel"
                      :originInfo="stackMixinOriginList"
                      :matchInfo="stackMixinMatchList"
                      :customBrandList="customBrandList"
                      :regionListByBu="regionListByBu"
                      :selectedOrgCode="selectedOrgCode"
                    >
                    </PerfectThemeConfigMixing>
                  </div>
                </div>
              </div>
            </div>

            <!-- 货架任务 -->
            <div
              v-show="activeName === '货架任务' && taskCheckedList[1].checked"
            >
              <div class="content content-tab">
                <div class="row">
                  <div class="sub-title">单张拍照激励金额/周</div>
                  <div v-if="!isDetailPage && isBuUser" class="sub-title-mod">
                    <el-input-number
                      v-model="shelfMatchInfo.incentiveFee"
                      controls-position="right"
                      :min="0"
                      size="small" />
                  </div>
                  <div v-else class="sub-content">
                    {{
                      shelfMatchInfo.incentiveFee || 0
                    }}元
                  </div>
                </div>

                <div class="row" v-show="hasBonusFeeType">
                  <div class="sub-title require">
                    <div class="sub-title-main">
                      陈列费/周<span class="sub-title-unit">（元）</span>
                    </div>
                    <!-- <div class="sub-title-unit">（元）</div> -->
                    <div class="sub-title-mod">
                      {{ getChooseTypeHint("bonusFeeShelf") }}<br />
                      <span v-if="shelfOriginInfo.bonusFeeMin!==null&&!isDetailPage">{{
                        getScopeHint(
                          shelfOriginInfo.bonusFeeMax,
                          shelfOriginInfo.bonusFeeMin
                        )
                      }}</span>
                    </div>
                  </div>
                  <div class="sub-content">
                    <PerfectThemeMixField
                      ref="bonusFeeShelf"
                      commonKey="bonusFee"
                      :employeeLevel="employeeLevel"
                      :matchInfo="shelfMatchInfo"
                      :originInfo="shelfOriginInfo"
                      >元</PerfectThemeMixField
                    >
                  </div>
                </div>
                <div class="row" v-show="hasBonusBeerType">
                  <div class="sub-title require">
                    <div class="sub-title-main">
                      赠酒数/周<span class="sub-title-unit">（箱）</span>
                    </div>
                    <!-- <div class="sub-title-unit">（箱）</div> -->
                    <div class="sub-title-mod">
                      {{ getChooseTypeHint("bonusBeerShelf") }}<br />
                      <span v-if="shelfOriginInfo.bonusBeerMin!==null&&!isDetailPage">{{
                        getScopeHint(
                          shelfOriginInfo.bonusBeerMax,
                          shelfOriginInfo.bonusBeerMin
                        )
                      }}</span>
                    </div>
                  </div>
                  <div class="sub-content">
                    <PerfectThemeMixField
                      ref="bonusBeerShelf"
                      commonKey="bonusBeer"
                      :employeeLevel="employeeLevel"
                      :matchInfo="shelfMatchInfo"
                      :originInfo="shelfOriginInfo"
                      >箱</PerfectThemeMixField
                    >
                  </div>
                </div>
              </div>

              <!-- 货架任务 必备品 -->
              <div class="content margin-top-20">
                <div class="row">
                  <div class="sub-content">
                    <PerfectThemeConfigMandatory
                      ref="shelfMandatory"
                      :brandInfo="brandInfo"
                      :customBrandList="customBrandList"
                      :employeeLevel="employeeLevel"
                      :matchInfo="shelfMatchInfo"
                      :originInfo="shelfOriginInfo"
                      :regionListByBu="regionListByBu"
                      :selectedOrgCode="selectedOrgCode"
                    ></PerfectThemeConfigMandatory>
                  </div>
                </div>
              </div>

              <!-- 货架 组合陈列套餐配置 -->
              <div class="content margin-top-20">
                <div class="row">
                  <div class="sub-content">
                    <PerfectThemeConfigMixing
                      ref="shelfTaskMixing"
                      componentName="货架组合陈列套餐配置"
                      :employeeLevel="employeeLevel"
                      :originInfo="shelfMixinOriginList"
                      :matchInfo="shelfMixinMatchList"
                      :customBrandList="customBrandList"
                      :regionListByBu="regionListByBu"
                      :selectedOrgCode="selectedOrgCode"
                    >
                    </PerfectThemeConfigMixing>
                  </div>
                </div>
              </div>
            </div>

            <!-- 冰柜任务 -->
            <div
              v-show="activeName === '冰柜任务' && taskCheckedList[2].checked"
            >
              <div class="content content-tab">
                <div class="row">
                  <div class="sub-title">单张拍照激励金额/周</div>
                  <div v-if="!isDetailPage && isBuUser" class="sub-title-mod">
                    <el-input-number
                      v-model="coolerMatchInfo.incentiveFee"
                      controls-position="right"
                      :min="0"
                      size="small" />
                  </div>
                  <div v-else class="sub-content">
                    {{
                      coolerMatchInfo.incentiveFee || 0
                    }}元
                  </div>
                </div>

                <div class="row" v-show="hasBonusFeeType">
                  <div class="sub-title require">
                    <div class="sub-title-main">
                      陈列费/周<span class="sub-title-unit">（元）</span>
                    </div>
                    <!-- <div class="sub-title-unit">（元）</div> -->
                    <div class="sub-title-mod">
                      {{ getChooseTypeHint("bonusFeeCooler") }}<br />
                      <span v-if="coolerOriginInfo.bonusFeeMin!==null&&!isDetailPage">{{
                        getScopeHint(
                          coolerOriginInfo.bonusFeeMax,
                          coolerOriginInfo.bonusFeeMin
                        )
                      }}</span>
                    </div>
                  </div>
                  <div class="sub-content">
                    <PerfectThemeMixField
                      ref="bonusFeeCooler"
                      commonKey="bonusFee"
                      :employeeLevel="employeeLevel"
                      :matchInfo="coolerMatchInfo"
                      :originInfo="coolerOriginInfo"
                      >元</PerfectThemeMixField
                    >
                  </div>
                </div>
                <div class="row" v-show="hasBonusBeerType">
                  <div class="sub-title require">
                    <div class="sub-title-main">
                      赠酒数/周<span class="sub-title-unit">（箱）</span>
                    </div>
                    <!-- <div class="sub-title-unit">（箱）</div> -->
                    <div class="sub-title-mod">
                      {{ getChooseTypeHint("bonusBeerCooler") }}<br />
                      <span v-if="coolerOriginInfo.bonusBeerMin!==null&&!isDetailPage">{{
                        getScopeHint(
                          coolerOriginInfo.bonusBeerMax,
                          coolerOriginInfo.bonusBeerMin
                        )
                      }}</span>
                    </div>
                  </div>
                  <div class="sub-content">
                    <PerfectThemeMixField
                      ref="bonusBeerCooler"
                      commonKey="bonusBeer"
                      :employeeLevel="employeeLevel"
                      :matchInfo="coolerMatchInfo"
                      :originInfo="coolerOriginInfo"
                      >箱</PerfectThemeMixField
                    >
                  </div>
                </div>
              </div>
              <!-- 冰柜任务 必备品 -->
              <div class="content margin-top-20">
                <div class="row">
                  <div class="sub-content">
                    <PerfectThemeConfigMandatory
                      ref="coolerMandatory"
                      :brandInfo="brandInfo"
                      :customBrandList="customBrandList"
                      :employeeLevel="employeeLevel"
                      :matchInfo="coolerMatchInfo"
                      :originInfo="coolerOriginInfo"
                      :regionListByBu="regionListByBu"
                      :selectedOrgCode="selectedOrgCode"
                    ></PerfectThemeConfigMandatory>
                  </div>
                </div>
              </div>

              <!-- 冰柜 组合陈列套餐配置 -->
              <div class="content margin-top-20">
                <div class="row">
                  <div class="sub-content">
                    <PerfectThemeConfigMixing
                      ref="coolerTaskMixing"
                      componentName="冰柜组合陈列套餐配置"
                      :employeeLevel="employeeLevel"
                      :originInfo="coolerMixinOriginList"
                      :matchInfo="coolerMixinMatchList"
                      :customBrandList="customBrandList"
                      :regionListByBu="regionListByBu"
                      :selectedOrgCode="selectedOrgCode"
                    >
                    </PerfectThemeConfigMixing>
                  </div>
                </div>
              </div>
            </div>
          </el-tabs>
        </div>

        <!-- 底部操作 -->
        <div class="operate" v-show="!loading">
          <div class="tool-btns" v-if="$route.query.class !== 'detail'">
            <!-- <el-button type="primary" @click="resetConfig()">重置</el-button> -->
            <el-button
              type="danger"
              :loading="submitLoading"
              @click="handleConfirm()"
              >{{ pageType === "config" ? "生成套餐" : "修改套餐" }}</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <!-- <el-dialog
      title="活动主题"
      :visible.sync="showThemeNameEdit"
      :close-on-click-modal="false"
      :show-close="true"
      width="400px">
      <div>
        <el-input v-model="themeName" placeholder="请输入活动主题"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showThemeNameEdit = false">取 消</el-button>
        <el-button type="danger" @click="handleConfirmTheme">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ContentHeader from '../../components/content-header'
import PerfectThemeOrg from './components/perfect-theme-org'
import PerfectThemeMixField from './components/perfect-theme-mix-field'
import PerfectThemeCheckbox from './components/perfect-theme-checkbox.vue'
import PerfectThemeBrand from './components/perfect-theme-brand.vue'
import PerfectThemeConfigDesign from './components/perfect-theme-config-design.vue'
import PerfectThemeConfigMandatory from './components/perfect-theme-config-mandatory.vue'
import PerfectThemeConfigMixing from './components/perfect-theme-config-mixing.vue'

export default {
  name: 'perfect-theme-config',
  components: {
    ContentHeader,
    PerfectThemeOrg, // 选择区域相关
    PerfectThemeMixField, // 选择 或 填写数字范围 组件
    PerfectThemeCheckbox, // 按钮多选组件
    PerfectThemeBrand, // 品牌 子品牌展示
    PerfectThemeConfigDesign, // 混堆设计相关
    PerfectThemeConfigMandatory, // 必备品相关
    PerfectThemeConfigMixing // 组合陈列套餐
  },
  data () {
    return {
      loading: false,
      submitLoading: false,
      employeeLevel: null,
      themeDefineId: null,
      pageType: '',
      class: '',
      orgName: '',
      orgList: [],
      tradePerfectThemeDefineDTO: {}, // 当前页面操作的实际数据
      originDefineInfo: {}, // 默认展示数据

      regionListByBu: [], // bu对应区域列表

      originInfo: {}, // 默认展示源数据
      matchInfo: {}, // 实际操作的数据

      taskCheckedList: [
        // 可选任务列表
        {
          title: '堆箱任务',
          key: '01',
          checked: true,
          showTask: true
        },
        {
          title: '货架任务',
          key: '02',
          checked: true,
          showTask: true
        },
        {
          title: '冰柜任务',
          key: '03',
          checked: true,
          showTask: true
        }
      ],
      activeName: '堆箱任务',

      refsNameArr: [
        'org', // BU Region
        'execWeek', // 执行周数
        'bonusType', // 费用返还方式
        'bonusBeerSku', // 赠酒SKU
        'trackType', // 陈列追踪方式

        'stackSize', // 单品牌堆箱规格
        'stackTaskDesign', // 混堆设计
        'bonusFeeStack', // 堆箱陈列费
        'bonusBeerStack', // 堆箱赠酒数量
        'bonusBeerStack', // 堆箱赠酒数量
        'stackTaskMixing', // 堆箱组合陈列

        'bonusFeeCooler', // 冰柜陈列费
        'bonusBeerCooler', // 冰柜赠酒数量
        'coolerMandatory', // 冰柜必备品
        'coolerTaskMixing', // 货架组合陈列

        'bonusFeeShelf', // 货架陈列费
        'bonusBeerShelf', // 货架赠酒数量
        'shelfMandatory', // 货架必备品
        'shelfTaskMixing' // 货架组合陈列
      ],

      brandInfo: {},
      customBrandList: [],

      stackOriginInfo: {},
      stackMatchInfo: {},
      stackMixinOriginList: [], // 堆箱组合陈列
      stackMixinMatchList: [], // 堆箱组合陈列

      shelfOriginInfo: {},
      shelfMatchInfo: {},
      shelfMixinOriginList: [], // 货架组合陈列
      shelfMixinMatchList: [], // 货架组合陈列

      coolerOriginInfo: {},
      coolerMatchInfo: {},
      coolerMixinOriginList: [], // 冰柜组合陈列
      coolerMixinMatchList: [], // 冰柜组合陈列

      hasBonusFeeType: false, // 线上/线下现金返还
      hasBonusBeerType: false, // 赠酒返还

      checkedResult: true,
      currentIndex: 0,

      showThemeNameEdit: false,
      themeName: '',

      selectedOrgCode: ''
    }
  },
  watch: {
    // 勾选任务
    taskCheckedList: {
      deep: true,
      immediate: true,
      handler () {
        for (let i = 0; i < this.taskCheckedList.length; i++) {
          if (this.taskCheckedList[i].checked) {
            this.activeName = this.taskCheckedList[i].title
            return
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isDetailPage () {
      return this.class === 'detail'
    },
    getTaskContentWidth () {
      let arr = []
      arr = this.taskCheckedList.filter(item => {
        return item.showTask
      })
      return arr.length === 3 ? 'space-between' : ' start'
    },
    isBuUser () {
      return this.employeeLevel && this.employeeLevel > 50
    }
  },
  created () {
    this.$store.dispatch('getDictByName', 'tradePerfectMandatorySpecsMap')
    this.$store.dispatch('getDictByName', 'tradePerfectScopeDetailSpecMap')
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.employeeLevel = this.userInfo.employeeLevel
      this.pageType = this.$route.query.handleType
      this.class = this.$route.query.class
      this.themeDefineId = this.$route.query.themeDefineId
      this.getInfo()
    },

    // 获取详情
    getInfo () {
      this.loading = true
      this.$store
        .dispatch('getPerfectThemeDefineInfo', this.themeDefineId)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            let data = res.data.resultData
            this.orgList = data.orgList || [] // 区域的数据
            this.tradePerfectThemeDefineDTO = data.tradePerfectThemeDefineDTO // 当前页面操作的实际数据
            this.originDefineInfo = data.originDefineInfo // 默认展示数据
            if (this.employeeLevel > 50) {
              this.getRegionListByBu(this.tradePerfectThemeDefineDTO.orgCode)
            }
            this.formatData()
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取区域列表
    getRegionListByBu (code) {
      let params = {
        buCode: code
      }
      this.$store
        .dispatch('getRegionListByBu', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.regionListByBu = res.data.resultData.regionList || []
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    setOrgCode (code) {
      console.log('setOrgCode')
      if (this.employeeLevel <= 50) {
        this.selectedOrgCode = code
      }
    },

    // 初始化数据处理
    formatData () {
      // 定义中 originInfo 均用作展示  matchInfo 均用作历史记录匹配
      let dtoInfo = this.tradePerfectThemeDefineDTO
      let defineInfo = this.originDefineInfo

      // 新建：originDefineInfo无用  tradePerfectThemeDefineDTO展示
      // 新建 用该id的信息展示
      if (this.pageType === 'config') {
        this.originInfo = dtoInfo
        this.matchInfo = {}
        if (this.originInfo.tradePerfectTaskDefineList.length) {
          this.originInfo.tradePerfectTaskDefineList.forEach(item => {
            // 堆箱
            if (item.taskType === '01') {
              this.stackOriginInfo = item
              // 组合陈列套餐
              this.stackMixinOriginList = item.mixinDisplayScopeList || []
            }
            // 货架
            if (item.taskType === '02') {
              this.shelfOriginInfo = item
              // 组合陈列套餐
              this.shelfMixinOriginList = item.mixinDisplayScopeList || []
            }
            // 冰柜
            if (item.taskType === '03') {
              this.coolerOriginInfo = item
              // 组合陈列套餐
              this.coolerMixinOriginList = item.mixinDisplayScopeList || []
            }
          })
        }
      }

      // 修改：originDefineInfo展示  tradePerfectThemeDefineDTO匹配
      // 修改 用上级的信息展示 该id的信息匹配
      if (this.pageType === 'update') {
        this.originInfo = defineInfo
        this.matchInfo = dtoInfo
        if (this.originInfo.tradePerfectTaskDefineList.length) {
          this.originInfo.tradePerfectTaskDefineList.forEach(item => {
            if (item.taskType === '01') {
              this.stackOriginInfo = item
              this.stackMixinOriginList = item.mixinDisplayScopeList || []
            }
            if (item.taskType === '02') {
              this.shelfOriginInfo = item
              this.shelfMixinOriginList = item.mixinDisplayScopeList || []
            }
            if (item.taskType === '03') {
              this.coolerOriginInfo = item
              this.coolerMixinOriginList = item.mixinDisplayScopeList || []
            }
          })
        }

        if (this.matchInfo.tradePerfectTaskDefineList.length) {
          this.matchInfo.tradePerfectTaskDefineList.forEach(item => {
            if (item.taskType === '01') {
              this.stackMatchInfo = item
              this.stackMixinMatchList = item.mixinDisplayScopeList || []
            }
            if (item.taskType === '02') {
              this.shelfMatchInfo = item
              this.shelfMixinMatchList = item.mixinDisplayScopeList || []
            }
            if (item.taskType === '03') {
              this.coolerMatchInfo = item
              this.coolerMixinMatchList = item.mixinDisplayScopeList || []
            }
          })
        }
      }

      // 特殊处理激励费用
      if (!this.stackMatchInfo.incentiveFee && this.stackMatchInfo.incentiveFee !== 0) {
        this.stackMatchInfo.incentiveFee = this.stackOriginInfo.incentiveFee
      }
      if (!this.shelfMatchInfo.incentiveFee && this.shelfMatchInfo.incentiveFee !== 0) {
        this.shelfMatchInfo.incentiveFee = this.shelfOriginInfo.incentiveFee
      }
      if (!this.coolerMatchInfo.incentiveFee && this.coolerMatchInfo.incentiveFee !== 0) {
        this.coolerMatchInfo.incentiveFee = this.coolerOriginInfo.incentiveFee
      }

      // 处理品牌展示
      this.brandInfo = {
        brand: dtoInfo.brandList,
        subBrand: dtoInfo.subBrandList
      }

      // 处理匹配品牌与子品牌
      let brandList = Object.assign([], dtoInfo.brandList)
      let subBrandList = Object.assign([], dtoInfo.subBrandList)
      if (brandList.length && subBrandList.length) {
        brandList.forEach(brand => {
          this.$set(brand, 'subBrandList', [])
          subBrandList.forEach(subBrand => {
            if (brand.abiBrandId === subBrand.parentBrandId) {
              brand.subBrandList.push(subBrand)
            }
          })
        })
      }

      this.customBrandList = brandList

      // 处理勾选的任务
      if (this.pageType === 'config') {
        // 上级未选择的任务 下级不能进行配置
        let originConfigArr = this.originInfo.taskTypeScope
          ? this.originInfo.taskTypeScope.split(',')
          : ['01', '02', '03']

        if (this.taskCheckedList.length) {
          this.taskCheckedList.forEach(item => {
            // 上级未配置的则不显示
            item.showTask = originConfigArr.indexOf(item.key) > -1
            item.checked = originConfigArr.indexOf(item.key) > -1
          })
        }
      } else {
        let matchUpdateArr = this.matchInfo.taskTypeScope
          ? this.matchInfo.taskTypeScope.split(',')
          : ['01', '02', '03']
        let originUpdateArr = this.originInfo.taskTypeScope
          ? this.originInfo.taskTypeScope.split(',')
          : ['01', '02', '03']

        if (this.taskCheckedList.length) {
          this.taskCheckedList.forEach(item => {
            // 上级未配置的则不显示
            item.showTask = originUpdateArr.indexOf(item.key) > -1
            item.checked = matchUpdateArr.indexOf(item.key) > -1
          })
        }
      }

      // if (this.taskCheckedList.length) {
      //   this.taskCheckedList.forEach(item => {
      //     item.showTask = taskTypeScopeArr.indexOf(item.key) > -1
      //     item.checked = taskTypeScopeArr.indexOf(item.key) > -1
      //   })
      // }

      this.setData()
    },

    // 设置各个组件里的默认数据
    setData () {
      this.$nextTick(() => {
        if (this.refsNameArr.length) {
          this.refsNameArr.forEach(item => {
            console.log('setData', item)
            if (item === 'stackTaskDesign') return
            this.$refs[item].setData()
          })
        }
      })
    },

    // // 编辑活动主题
    // editThemeName () {
    //   console.log('editThemeName')
    //   this.showThemeNameEdit = true
    // },
    // // 确认活动主题
    // handleConfirmTheme () {
    //   this.$confirm('确认修改活动主题？').then(() => {
    //     this.originInfo.themeName = this.themeName
    //     this.originInfo.buThemeName = this.themeName
    //     this.showThemeNameEdit = false
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // },

    // 费用返还方式结果
    bonusTypeChange (obj) {
      // 现金返还
      this.hasBonusFeeType = obj.hasBonusFeeType
      // 赠酒返还
      this.hasBonusBeerType = obj.hasBonusBeerType
    },

    // 新增/删除单品牌堆箱规格
    handleAddNewStackSize (value) {
      let stackTaskDesign = this.$refs.stackTaskDesign
      let stackSizeScopeArr = []
      if (value.length) {
        value.forEach(item => {
          stackSizeScopeArr.push(item.value)
        })
      }

      stackTaskDesign.newStackSizeList = stackSizeScopeArr
    },

    // 格式化 混合填写组件数据
    formatMixFiledData (keyWord, element) {
      let params = {}
      let ele = element || this.$refs[keyWord]
      params[`${keyWord}ChooseType`] = ele.chooseType
      params[`${keyWord}Max`] = ele.max
      params[`${keyWord}Min`] = ele.min
      let arr = ele.isRegion ? ele.getScope() : ele.scope
      let resultArr = []
      // 去空
      if (arr.length) {
        resultArr = arr.filter(item => {
          return Boolean(item)
        })
      }
      params[`${keyWord}Scope`] = resultArr.join(',')
      return params
    },

    // 获取混合填写组件 选项提示
    getChooseTypeHint (keyWord, element) {
      let ele = element || this.$refs[keyWord]
      let chooseType = ele ? ele.chooseType : ''
      return chooseType === '01' ? '范围填写模式' : '固定选项模式'
    },

    // 获取混合填写组件 范围提示
    getScopeHint (max, min) {
      let hint = ''
      if (this.getEmpty(max)) {
        hint = `（范围:${min}~${max}）`
      } else {
        hint = `（最小值:${min}）`
      }
      return hint
    },

    getEmpty (value) {
      return value !== undefined && value !== null
    },

    // 格式化 选择框组数据
    formatCheckBoxData (keyWord) {
      let scope
      let element = this.$refs[keyWord]
      let length = element.checkedInfo.length
      if (!length) return
      // 非单品牌堆箱规格
      if (keyWord !== 'stackSize') {
        element.checkedInfo.forEach(item => {
          if (item.checked) {
            scope = scope ? scope.concat(',' + item.key) : item.key
          }
        })
        return scope
      } else {
        // 单品牌堆箱规格
        let stackPackList = []
        element.checkedInfo.forEach(item => {
          if (item.checked) {
            let obj = {
              defineType: '01',
              stackType: '02',
              scopeDefineId: item.scopeDefineId,
              stackPackSize: item.key,
              standardFlag: item.allowDelete ? '0' : '1' // 是否标准配置 1是 0否
            }
            stackPackList.push(obj)
          }
        })
        return stackPackList
      }
    },

    // 组装主表参数
    handleParamsMain () {
      let params = {}
      // 活动主题
      // params.themeName = this.originInfo.buThemeName
      // 销售是否必选经销商
      // params.flagWsRequired = this.matchInfo.flagWsRequired
      // params.orgLevel = this.matchInfo.orgLevel

      // bu、Region  orgCodes
      let org = this.$refs.org
      params.orgCodes = org.orgCodes.join(',')

      // 执行周数 execWeekChooseType  execWeekScope/execWeekMin execWeekMax
      params = Object.assign({}, params, this.formatMixFiledData('execWeek'))

      // 费用返还方式 bonusTypeScope
      params.bonusTypeScope = this.formatCheckBoxData('bonusType')

      // 赠酒sku  bonusBeerScope  [{skuCode:"111",skuName:"百威460"}]
      if (this.hasBonusBeerType) {
        let bonusBeerSku = this.$refs.bonusBeerSku
        params.bonusBeerScope = []
        if (bonusBeerSku.checkedInfo.length) {
          bonusBeerSku.checkedInfo.forEach(item => {
            if (item.checked) {
              params.bonusBeerScope.push({
                skuCode: item.skuCode,
                skuName: item.skuName
              })
            }
          })
        }

        params.bonusBeerScope = JSON.stringify(params.bonusBeerScope)
      }

      // 陈列追踪方式  trackTypeScope
      params.trackTypeScope = this.formatCheckBoxData('trackType')

      // 任务类型  taskTypeScope
      let taskScope = ''
      if (this.taskCheckedList.length) {
        this.taskCheckedList.forEach(item => {
          if (item.checked) {
            taskScope = taskScope ? taskScope.concat(',' + item.key) : item.key
          }
        })
      }

      params.taskTypeScope = taskScope
      return params
    },

    // 组装堆箱任务参数
    handleParamsStack () {
      let params = {}

      params.taskType = '01'

      // 单品牌堆箱规格 stackPackScopeList
      params.stackPackScopeList = this.formatCheckBoxData('stackSize')
      // console.log('handleParamsStack', params.stackPackScopeList)
      // 堆箱陈列费 bonusFeeChooseType  bonusFeeScope/bonusFeeMin bonusFeeMax
      if (this.hasBonusFeeType) {
        params = Object.assign(
          {},
          params,
          this.formatMixFiledData('bonusFee', this.$refs.bonusFeeStack)
        )
      }

      // 堆箱赠酒数量 bonusBeerChooseType  bonusBeerScope/bonusBeerMin bonusBeerMax
      if (this.hasBonusBeerType) {
        params = Object.assign(
          {},
          params,
          this.formatMixFiledData('bonusBeer', this.$refs.bonusBeerStack)
        )
      }

      // 处理堆箱混堆设计规格 mixinPackScope [{ defineName: 'A', stackPackSize: '3*4', stackPackSubBrands: '20AAHF00,20ACKF00,20ABZY00,20AAHP00'}, {} ....]
      let stackTaskDesignArr = this.handleStackDesign()
      // params.mixinPackScope = JSON.stringify(stackTaskDesignArr)
      params.mixinPackScopeList = stackTaskDesignArr

      // 组装激励金额
      params.incentiveFee = this.stackMatchInfo.incentiveFee || 0

      if (this.pageType === 'update') {
        params.taskDefineId = this.stackMatchInfo
          ? this.stackMatchInfo.taskDefineId
          : ''
      }
      // 堆箱-组合陈列套餐参数
      params.mixinDisplayScopeList = this.handleParamsMixing('stackTaskMixing')

      return params
    },

    // 组装货架任务参数
    handleParamsShelf () {
      let params = {}
      params.taskType = '02'

      // 货架陈列费 bonusFeeChooseType  bonusFeeScope/bonusFeeMin bonusFeeMax
      if (this.hasBonusFeeType) {
        params = Object.assign(
          {},
          params,
          this.formatMixFiledData('bonusFee', this.$refs.bonusFeeShelf)
        )
      }

      // 货架赠酒数量 bonusBeerChooseType  bonusBeerScope/bonusBeerMin bonusBeerMax
      if (this.hasBonusBeerType) {
        params = Object.assign(
          {},
          params,
          this.formatMixFiledData('bonusBeer', this.$refs.bonusBeerShelf)
        )
      }

      // 处理货架必备品 mandatoryItemScope [{defineName:'X', items:[{brand:'20AAHF', subBrand:'20AAHF00',spec:'bigCan',qty:6}]}]
      let shelfMandatoryArr = this.handleShelfMandatory('shelf')
      // params.mandatoryItemScope = JSON.stringify(shelfMandatoryArr)
      params.mandatoryScopeList = shelfMandatoryArr

      // 组装激励金额
      params.incentiveFee = this.shelfMatchInfo.incentiveFee || 0

      if (this.pageType === 'update') {
        params.taskDefineId = this.shelfMatchInfo
          ? this.shelfMatchInfo.taskDefineId
          : ''
      }
      // 组装货架-组合陈列套餐参数
      params.mixinDisplayScopeList = this.handleParamsMixing('shelfTaskMixing')

      return params
    },

    // 组装冰柜任务参数
    handleParamsCooler () {
      let params = {}
      params.taskType = '03'

      // 冰柜陈列费 bonusFeeChooseType  bonusFeeScope/bonusFeeMin bonusFeeMax
      if (this.hasBonusFeeType) {
        params = Object.assign(
          {},
          params,
          this.formatMixFiledData('bonusFee', this.$refs.bonusFeeCooler)
        )
      }

      // 冰柜赠酒数量 bonusBeerChooseType  bonusBeerScope/bonusBeerMin bonusBeerMax
      if (this.hasBonusBeerType) {
        params = Object.assign(
          {},
          params,
          this.formatMixFiledData('bonusBeer', this.$refs.bonusBeerCooler)
        )
      }

      // 处理冰柜必备品 mandatoryItemScope [{name:'X', items:[{brand:'20AAHF', subBrand:'20AAHF00',spec:'bigCan',qty:6}]}]
      let coolerMandatoryArr = this.handleShelfMandatory('cooler')
      // params.mandatoryItemScope = JSON.stringify(coolerMandatoryArr)
      params.mandatoryScopeList = coolerMandatoryArr

      // 组装激励金额
      params.incentiveFee = this.coolerMatchInfo.incentiveFee || 0

      if (this.pageType === 'update') {
        params.taskDefineId = this.coolerMatchInfo
          ? this.coolerMatchInfo.taskDefineId
          : ''
      }
      // 组装冰柜-组合陈列套餐参数
      params.mixinDisplayScopeList = this.handleParamsMixing('coolerTaskMixing')

      return params
    },
    // 组装组合陈列套餐参数
    handleParamsMixing (refName) {
      let refs = this.$refs[refName]
      let arr = []
      refs.mixinDisplayList.forEach(item => {
        // 堆箱信息
        let obj = {
          tradePerfectScopeDetailList: this.handleParamsMixingProduct(item.tradePerfectScopeDetailList),
          defineType: item.defineType,
          stackType: item.stackType,
          stackPackSize: item.stackPackSize,
          defineName: item.defineName,
          scopeDefineId: item.scopeDefineId
        }
        // obj.tradePerfectScopeDetailList = item.tradePerfectScopeDetailList
        // obj.defineType = item.defineType
        // obj.stackType = item.stackType
        // 单品牌堆箱
        if (item.stackType === '01') {
          obj.stackPackBrands = item.brandCode || item.stackPackBrands
          obj.stackPackSubBrands = item.subBrandCode || item.stackPackSubBrands
        } else {
          // 混堆
          let brandCode = []
          item.brandList.forEach(brand => {
            brandCode.push(brand.abiBrandCode)
          })
          obj.stackPackSubBrands = brandCode.join(',')
        }
        if (this.employeeLevel > 50) {
          let regionListTemp = item.regionList.filter(item => {
            return item
          })
          obj.regionCodes = regionListTemp.join(',')
          arr.push(obj)
        }
        // region 只 push 勾选的选项
        if (this.employeeLevel <= 50 && (this.pageType === 'update' || this.pageType === 'config')) {
          console.log('handleParamsMixing item3', item)
          if (item.checked) arr.push(obj)
        }
      })
      // console.log('handleParamsMixing', arr)
      return arr
    },
    // 组装组合陈列套餐——产品信息
    handleParamsMixingProduct (arr) {
      return arr.map(item => {
        item = {
          brandCode: item.brandCode,
          subBrandCode: item.subBrandCode,
          multiPackFlag: item.multiPackFlag,
          multiPackSpec: item.multiPackSpec,
          minDisplayQty: item.minDisplayQty,
          volume: item.volume,
          scopeDefineId: item.scopeDefineId,
          detailId: item.detailId,
          rowQty: item.rowQty
        }
        return item
      })
    },

    // 处理堆箱混堆设计规格
    handleStackDesign () {
      let stackTaskDesign = this.$refs.stackTaskDesign
      let stackTaskDesignArr = []
      if (this.employeeLevel > 50) {
        if (stackTaskDesign.mixPackList.length) {
          stackTaskDesign.mixPackList.forEach(item => {
            let obj = {
              defineType: '02',
              scopeDefineId: item.scopeDefineId,
              defineName: item.defineName,
              stackPackSize: item.stackPackSize,
              regionCodes: item.regionCodeList.join(',')
            }
            if (item.brandList.length && item.stackPackSize) {
              item.brandList.forEach((sub, index) => {
                let separator = index === item.brandList.length - 1 ? '' : ','
                if (obj.stackPackSubBrands) {
                  obj.stackPackSubBrands += sub.abiBrandCode + separator
                } else {
                  obj.stackPackSubBrands = sub.abiBrandCode + separator
                }
              })
            }
            stackTaskDesignArr.push(obj)
          })
        }
      } else {
        let checkedArr = stackTaskDesign.checkedIndexList
        if (checkedArr.length) {
          checkedArr.forEach((item, index) => {
            if (item) {
              let misPackItem = Object.assign({}, stackTaskDesign.mixPackList[index])
              let obj = {
                defineType: '02',
                scopeDefineId: misPackItem.scopeDefineId,
                defineName: misPackItem.defineName,
                stackPackSize: misPackItem.stackPackSize,
                stackPackSubBrands: misPackItem.stackPackSubBrands
              }
              stackTaskDesignArr.push(obj)
            }
          })
        }
      }
      return stackTaskDesignArr
    },
    // 处理货架 /冰柜 必备品
    handleShelfMandatory (taskType) {
      let mandatory = this.$refs[`${taskType}Mandatory`]
      let itemList = Object.assign([], mandatory.mandatoryItemList)

      let seletedItemList = []

      if (itemList && itemList.length) {
        itemList.forEach(item => {
          item.regionCodes = item.regionCodeList.join(',')
          let objItem = Object.assign({}, item)
          if (this.employeeLevel <= 50) {
            if (objItem.checked) {
              seletedItemList.push(objItem)
            }
          } else {
            seletedItemList.push(objItem)
          }
        })
      }

      // 去掉冗余字段
      if (seletedItemList && seletedItemList.length) {
        seletedItemList.map(item => {
          // 去掉主表冗余字段
          for (let key in item) {
            if (
              key !== 'defineName' &&
              key !== 'tradePerfectScopeDetailList' &&
              key !== 'regionCodes' &&
              key !== 'scopeDefineId'
            ) {
              delete item[key]
            }
          }

          // 去掉items内冗余字段
          if (item.items && item.items.length) {
            item.items.forEach(itemsObj => {
              for (let key in itemsObj) {
                if (
                  key !== 'brandCode' &&
                  key !== 'subBrandCode' &&
                  key !== 'volume' && // 容量
                  key !== 'minDisplayQty' && // 最小陈列件
                  key !== 'multiPackFlag' && // 是否多联包
                  key !== 'multiPackSpec' && // 多联包规格
                  key !== 'scopeDefineId' &&
                  key !== 'detailId' &&
                  key !== 'rowQty'
                ) {
                  delete itemsObj[key]
                }
              }
            })
          }
        })
      }
      return seletedItemList
    },

    // 数据处理
    handleConfirm () {
      // console.log('handleConfirm')
      let hint = this.pageType === 'config' ? '生成套餐' : '修改套餐'
      this.$confirm(`确认${hint}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 必填项检测
          this.checkData()
          if (!this.checkedResult) {
            // this.$message.warning('请正确填写所有数据')
            return
          }

          let params = {}

          // 组装主表参数
          let paramsMain = Object.assign({}, this.handleParamsMain())

          // 组装堆箱任务参数
          let paramsTaskStack = Object.assign({}, this.handleParamsStack())
          console.log('paramsTaskStack', paramsTaskStack)

          // 组装货架任务参数
          let paramsTaskShelf = Object.assign({}, this.handleParamsShelf())
          console.log('paramsTaskShelf', paramsTaskShelf)

          // 组装冰柜任务参数
          let paramsTaskCooler = Object.assign({}, this.handleParamsCooler())
          console.log('paramsTaskCooler', paramsTaskCooler)
          // 组装冰柜-组合陈列套餐参数
          // let paramsTaskCoolerMixing = this.handleParamsMixing('stackCoolerMixing')

          // ------------------------//
          // 组装最后所有参数
          params = Object.assign({}, paramsMain)
          params.tradePerfectTaskDefineList = []
          console.log('params', params)

          // 勾选堆箱任务 stack
          if (this.taskCheckedList[0].checked) {
            params.tradePerfectTaskDefineList.push(paramsTaskStack)
          }
          // 勾选货架任务 shelf
          if (this.taskCheckedList[1].checked) {
            params.tradePerfectTaskDefineList.push(paramsTaskShelf)
          }
          // 勾选冰柜任务 cooler
          if (this.taskCheckedList[2].checked) {
            params.tradePerfectTaskDefineList.push(paramsTaskCooler)
          }
          // ------------------------//
          // console.log('111', params)
          this.submit(params)
        })
        .catch(() => {})
    },

    // 提交
    submit (params) {
      console.log('submit')
      this.submitLoading = true
      let api = ''
      let hint = ''

      if (this.$route.query.handleType === 'config') {
        api = 'perfectThemeDefineConfig'
        params.originDefineId = this.themeDefineId
        hint = '生成套餐'
      }
      if (this.$route.query.handleType === 'update') {
        api = 'perfectThemeDefineUpdate'
        params.themeDefineId = this.themeDefineId
        hint = '修改套餐'
      }
      this.$store
        .dispatch(api, params)
        .then(res => {
          this.submitLoading = false
          if (res.data.resultCode === '0') {
            this.$message.success(`${hint}成功`)
            this.$router.replace('/trade/perfect-theme-list')
          }
        })
        .catch(() => {
          this.submitLoading = false
        })
    },

    // 检查数据 具体内容组件内自己检查 将结果返回该组件
    checkData () {
      this.checkedResult = true
      if (this.refsNameArr.length) {
        this.refsNameArr.forEach(name => {
          this.$refs[name].checkData()
        })
      }

      for (let i = 0; i < this.refsNameArr.length; i++) {
        let name = this.refsNameArr[i]
        // console.log('start check name:', name)
        if (name === 'bonusBeerSku' && this.hasBonusBeerType) {
          this.checkedResult = this.$refs[name].checkedResult
        } else if (
          (name === 'stackSize' || name === 'stackTaskDesign' || name === 'stackTaskMixing') &&
          this.taskCheckedList[0].checked
        ) {
          // 混堆设计类型 单品牌堆箱规格 组合陈列套餐三选一
          this.checkedResult = this.$refs.stackSize.checkedResult ||
          this.$refs.stackTaskDesign.checkedResult ||
          this.$refs.stackTaskMixing.checkedResult
        } else if (
          name === 'bonusFeeStack' &&
          this.taskCheckedList[0].checked &&
          this.hasBonusFeeType
        ) {
          this.checkedResult = this.$refs[name].checkedResult
        } else if (
          name === 'bonusBeerStack' &&
          this.taskCheckedList[0].checked &&
          this.hasBonusBeerType
        ) {
          this.checkedResult = this.$refs[name].checkedResult
        } else if (
          name === 'bonusFeeCooler' &&
          this.taskCheckedList[2].checked &&
          this.hasBonusFeeType
        ) {
          this.checkedResult = this.$refs[name].checkedResult
        } else if (
          name === 'bonusBeerCooler' &&
          this.taskCheckedList[2].checked &&
          this.hasBonusBeerType
        ) {
          this.checkedResult = this.$refs[name].checkedResult
        } else if (
          (
            name === 'coolerMandatory' ||
            name === 'coolerTaskMixing'
          ) &&
          this.taskCheckedList[2].checked
        ) {
          // 冰柜必备品 冰柜组合陈列套餐二选一
          this.checkedResult = this.$refs.coolerTaskMixing.checkedResult ||
          this.$refs.coolerMandatory.checkedResult
        } else if (
          name === 'bonusFeeShelf' &&
          this.taskCheckedList[1].checked &&
          this.hasBonusFeeType
        ) {
          this.checkedResult = this.$refs[name].checkedResult
        } else if (
          name === 'bonusBeerShelf' &&
          this.taskCheckedList[1].checked &&
          this.hasBonusBeerType
        ) {
          this.checkedResult = this.$refs[name].checkedResult
        } else if (
          // 货架必备品与货架组合陈列 二选一
          (
            name === 'shelfMandatory' ||
            name === 'shelfTaskMixing'
          ) &&
          this.taskCheckedList[1].checked
        ) {
          // 冰柜必备品 冰柜组合陈列套餐二选一
          this.checkedResult = this.$refs.shelfMandatory.checkedResult ||
          this.$refs.shelfTaskMixing.checkedResult
        } else if (
          name === 'org' ||
          name === 'execWeek' ||
          name === 'bonusType' ||
          name === 'trackType'
        ) {
          this.checkedResult = this.$refs[name].checkedResult
        }
        if (!this.checkedResult) {
          this.showMessage(name)
          console.log('check not pass name:', name)
          break
        }
      }
    },
    // 添加对应的提示
    showMessage (name) {
      let messageObj = {
        execWeek: '活动配置——执行周数', // 执行周数
        bonusType: '活动配置——费用返还方式', // 费用返还方式
        bonusBeerSku: '活动配置——赠酒SKU', // 赠酒SKU
        trackType: '活动配置——陈列追踪方式', // 陈列追踪方式

        stackSize: '堆箱任务——单品牌堆箱规格 或 混堆设计 或 组合陈列套餐', // 单品牌堆箱规格
        stackTaskDesign: '堆箱任务—— 单品牌堆箱规格 或 混堆设计 或 组合陈列套餐', // 混堆设计
        bonusFeeStack: '堆箱任务配置——陈列费', // 堆箱陈列费
        bonusBeerStack: '堆箱任务配置——赠酒数', // 堆箱赠酒数量

        bonusFeeCooler: '冰柜任务配置——陈列费', // 冰柜陈列费
        bonusBeerCooler: '冰柜任务配置——赠酒数', // 冰柜赠酒数量
        coolerMandatory: '冰柜任务——必备品/排面数 或 组合陈列套餐', // 冰柜必备品

        bonusFeeShelf: '货架任务配置——陈列费', // 货架陈列费
        bonusBeerShelf: '货架任务配置——赠酒数', // 货架赠酒数量
        shelfMandatory: '货架任务——必备品/排面数 或 组合陈列套餐' // 货架必备品
      }
      let hint = messageObj[name] || ''
      let hintMessage = hint ? `请正确配置 “${hint}” 部分数据` : '请正确配置所有数据'
      this.$message.warning({
        message: hintMessage,
        duration: 8000
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-container {
  width: 1350px;
}
.margin-top-20 {
  margin-top: 20px;
}
.perfect-theme {
  margin: 0 100px;
}
.primary-title {
  padding-left: 20px;
  line-height: 60px;
  font-size: 20px;
  font-weight: 600;
}
.content {
  padding: 20px 40px;
  background-color: #fff;
  border-radius: 10px;
  .row + .row {
    border-top: 1px solid #eee;
  }
  .row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 60px;
    .sub-title {
      width: 22%;
      // line-height: 40px;
      font-size: 16px;
      font-weight: 600;
      .sub-title-main {
        // line-height: 20px;
        margin-bottom: -20px;
      }
      .sub-title-unit,
      .sub-title-mod {
        width: 100px;
        // margin-top: -20px;
        margin-left: -5px;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
      }
      .sub-title-mod {
        color: #ce1332;
      }
    }
    .sub-content {
      width: 100%;
      .icon-edit {
        font-size: 24px;
        color: #409EFF;
        cursor: pointer;
      }
    }
    .require {
      position: relative;
      &::before {
        content: "*";
        font-size: 20px;
        width: 5px;
        height: 5px;
        color: red;
        position: absolute;
        top: 0;
        left: -10px;
      }
    }
  }
}

.task {
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin: 20px 0;
  border-radius: 10px;

  .task-wrapper {
    display: flex;
    // justify-content: space-between;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    line-height: 50px;
    color: #333;
    overflow: hidden;
    text-align: center;

    .task-content {
      align-content: center;
      width: 30%;
      margin:0 10px;
      height: 100px;
      background-color: #fff;
      border-radius: 10px;
      .task-title {
        font-size: 16px;
      }
    }
  }
}
.operate {
  width: 100%;
  text-align: center;
  margin: 20px 0;
}

// 任务多选样式
.taskCheckbox {
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #409eff;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox.is-bordered.is-checked {
    border-color: #409eff;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #409eff;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox__input .el-checkbox__inner {
    border-radius: 50px;
  }
  ::v-deep .el-checkbox__input:hover .el-checkbox__inner {
    border-color: #409eff;
    border-radius: 50px;
  }
}

// 任务tabs样式
::v-deep .el-tabs {
  .el-tabs__nav{
    border:none;
    border-radius: 10px 10px 0px 0px;
  }
  .el-tabs__item {
    border:none;
    margin:5px 30px;
    padding:0px!important;

  }
  .el-tabs__item.is-active {
    font-weight: 700;
    background: #fff;
    border-bottom: 2px solid rgb(234, 84, 5);
    color: rgb(234, 84, 5);
  }
  .el-tabs__item:hover{
    color: rgb(234, 84, 5);
  }
}

.content-tab{
  border-radius: 0px 10px 10px;
}
</style>
